<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-6">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div v-show="!popupParam.nearFlag" class="col-6">
          <c-select
            type="search"
            codeGroupCd="IIM_TYPE_CD"
            itemText="codeName"
            itemValue="code"
            name="accidentTypeCd"
            label="발생형태"
            v-model="searchParam.accidentTypeCd"
          ></c-select>
        </div>
        <div class="col-6">
          <c-select
            type="search"
            codeGroupCd="IIM_OCCUR_CD"
            itemText="codeName"
            itemValue="code"
            name="occurrenceCd"
            label="재해유형"
            v-model="searchParam.occurrenceCd"
          ></c-select>
        </div>
        <div class="col-6">
          <c-select
            type="search"
            stepperGrpCd="IIM_STATUS_PROCESS_CD"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="accidentStatusCd"
            label="진행상태"
            v-model="searchParam.accidentStatusCd"
          ></c-select>
        </div>
        <!-- <div class="col-6">
          <c-dept
            type="search"
            :isFirstValue="false"
            name="occurrenceDeptCd"
            label="LBL0002302"
            v-model="searchParam.occurrenceDeptCd"
          ></c-dept>
        </div>
        <div class="col-6">
          <c-datepicker
            :range="true"
            name="period"
            defaultStart="-6M"
            defaultEnd="6M"
            label="재해기간"
            v-model="searchParam.period"
          ></c-datepicker>
        </div>
        <div class="col-6">
          <c-field
            label="사고자"
            v-model="searchParam.accidentUserId"
          ></c-field>
        </div> -->
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="공정사고 목록"
      :columns="grid.columns"
      :data="grid.data"
      gridHeightAuto
      :selection="popupParam.type"
      rowKey="iimAccidentId"
      @rowDblclick="rowDblclick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn label="검색" icon="search" @btnClicked="getList" />
          <c-btn label="선택" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "process-accident-pop",
  props: {
    popupParam: {
      type: Object,
      default: function () {
        return {
          type: "multiple",
          accidentTypeCd: "",
          grade: "",
          accidentStatusCd: "",
          nearFlag: null,
        };
      },
    },
  },
  data() {
    return {
      grid: {
        columns: [
          {
            fix: true,
            name: "plantName",
            field: "plantName",
            label: "사업장",
            style: "width:100px",
            align: "center",
            sortable: true,
          },
          {
            fix: true,
            name: "accidentName",
            field: "accidentName",
            label: "재해명",
            style: "width:200px",
            align: "left",
            sortable: true,
            // type: "link",
          },
          {
            fix: true,
            name: "occurrenceDate",
            field: "occurrenceDate",
            style: "width:130px",
            label: "재해일시",
            align: "center",
            sortable: true,
          },
          {
            fix: true,
            name: "occurrenceDeptName",
            field: "occurrenceDeptName",
            label: "발생부서",
            style: "width:100px",
            align: "center",
            sortable: true,
          },
          {
            name: "accidentTypeName",
            field: "accidentTypeName",
            style: "width:100px",
            label: "발생형태",
            align: "center",
            sortable: true,
          },
          {
            name: "occurrenceName",
            field: "occurrenceName",
            style: "width:100px",
            label: "재해유형",
            align: "center",
            sortable: true,
          },
          {
            name: "woundSecName",
            field: "woundSecName",
            style: "width:100px",
            label: "상해부위(중)",
            align: "center",
            sortable: true,
          },
          {
            name: "accidentDate",
            field: "accidentDate",
            style: "width:180px",
            label: "요양기간",
            align: "center",
            sortable: true,
          },
          {
            name: "nursingCount",
            field: "nursingCount",
            style: "width:100px",
            label: "요양일수",
            align: "center",
            sortable: true,
          },
          {
            name: "hospitalCost",
            field: "hospitalCost",
            style: "width:100px",
            label: "병원진료비<br>(요양비)",
            align: "right",
            sortable: true,
          },
          {
            name: "occurrenceLocation",
            field: "occurrenceLocation",
            style: "width:130px",
            label: "재해장소",
            align: "left",
            sortable: true,
          },
          {
            name: "accidentNo",
            field: "accidentNo",
            label: "사고번호(품번)",
            style: "width:130px",
            align: "center",
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        startYmd: "",
        endYmd: "",
        accidentGrade: null,
        occurrenceDeptCd: "",
        accidentKindCdList: [],
        accidentStatusCd: null,
        nearFlag: null,
        accidentTypeCd: null
      },
      period: ["", ""],
      editable: true,
      searchUrl: "",
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        isFull: true,
        top: "",
        param: {},
        closeCallback: null,
      },
      isResult: false,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.listUrl = selectConfig.sop.iim.accident.process.list.url;
      // url setting
      // code setting
      if (this.popupParam.accidentStatusCd) {
        this.searchParam.accidentStatusCd = this.popupParam.accidentStatusCd;
      }
      if (this.popupParam.nearFlag === 'Y') {
        this.searchParam.accidentTypeCd = "ITC0000001";
        this.searchParam.nearFlag = this.popupParam.nearFlag;
      } else if (this.popupParam.nearFlag === 'N') {
        this.searchParam.accidentTypeCd = null;
        this.searchParam.nearFlag = this.popupParam.nearFlag;
      } else {
        this.searchParam.accidentTypeCd = this.popupParam.accidentTypeCd;
      }
      // list setting
      this.getList();
    },
    getList() {
      // this.searchParam.startYmd = this.period[0];
      // this.searchParam.endYmd = this.period[1];
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    select() {
      let selectData = this.$refs["table"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "안내",
          message: "공정사고를 선택하세요.",
          type: "warning", // success / info / warning / error
        });
      } else {
        this.$emit("closePopup", selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === "single") this.$emit("closePopup", [row]);
    },
  },
};
</script>
